module.exports = require("core-js-pure/stable/object/freeze");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/freeze.js
// module id = 592
// module chunks = 0 1